var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconaccordionDiet6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59463 1.16971C6.72684 1.16971 5.21267 2.68387 5.21267 4.55166C5.21267 6.41946 6.72684 7.93358 8.59463 7.93358C10.4624 7.93358 11.9765 6.41946 11.9765 4.55166C11.9765 2.68387 10.4624 1.16971 8.59463 1.16971ZM4.16406 4.55166C4.16406 2.10471 6.14767 0.121094 8.59463 0.121094C11.0415 0.121094 13.0252 2.10471 13.0252 4.55166C13.0252 6.99858 11.0415 8.98221 8.59463 8.98221C6.14767 8.98221 4.16406 6.99858 4.16406 4.55166Z",
    fill: "#314037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7496 1.16971C17.6009 1.16971 16.6697 2.10087 16.6697 3.24958C16.6697 4.39825 17.6009 5.32941 18.7496 5.32941C19.8983 5.32941 20.8294 4.39825 20.8294 3.24958C20.8294 2.10087 19.8983 1.16971 18.7496 1.16971ZM15.6211 3.24958C15.6211 1.52175 17.0218 0.121094 18.7496 0.121094C20.4774 0.121094 21.8781 1.52175 21.8781 3.24958C21.8781 4.97737 20.4774 6.37804 18.7496 6.37804C17.0218 6.37804 15.6211 4.97737 15.6211 3.24958Z",
    fill: "#314037"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.00390625 18.6148C-0.00390625 13.8656 3.84412 10.0176 8.59333 10.0176C13.3425 10.0176 17.1905 13.8656 17.1905 18.6148V19.3995H-0.00390625V18.6148ZM1.04923 18.3509H16.1374C15.9985 14.3031 12.6751 11.0662 8.59333 11.0662C4.51158 11.0662 1.18818 14.3031 1.04923 18.3509Z",
    fill: "#314037"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7486 8.46073C16.3956 8.46073 14.4016 10.0277 13.7629 12.1745L12.7578 11.8754C13.5254 9.29573 15.9194 7.41211 18.7486 7.41211C22.2023 7.41211 25.0021 10.2119 25.0021 13.6656V14.7107H15.3437V13.6621H23.9535C23.9516 10.7892 21.622 8.46073 18.7486 8.46073Z",
    fill: "#314037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconaccordionDiet6);
export default __webpack_public_path__ + "static/media/IconaccordionDiet6.911c9d02d87e1616c8c582c1f4384cf9.svg";
export { ForwardRef as ReactComponent };